export const handler = (element) => {
  const targetSelector = element.getAttribute("data-remove-target");
  const targetElement = document.querySelector(targetSelector);

  if (targetElement) {
    targetElement.remove();
  }
};
